// Debug log for stage status
// eslint-disable-next-line no-console
import React from 'react';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { Link } from 'react-router-dom';

import _ from 'lodash';

const CertSection = ({ i, periods }) => {
  // periods: [period1, period2, period3]

  // Get current period for stages 1-3, or empty array for stage 4
  let currentPeriod = [];
  if (i <= 3 && Array.isArray(periods)) {
    currentPeriod = periods[i - 1] || [];
  }

  // Check if current period's all answers are completed
  const isCurrentPeriodCompleted = Array.isArray(currentPeriod) && currentPeriod.length > 0
    && _.every(currentPeriod, (item) => item.status === 'completed');

  // Check if all periods are completed (for stage 4)
  const allPeriodsCompleted = Array.isArray(periods) && periods.length === 3
    && _.every(periods, (p) => Array.isArray(p) && p.length > 0 && _.every(p, (item) => item.status === 'completed'));

  // Download logic:
  // - Stages 1-3: can download if current period's all answers are finished
  // - Stage 4: can download if all periods are finished
  const showDownload = (i <= 3 && isCurrentPeriodCompleted) || (i === 4 && allPeriodsCompleted);

  // Map i to assignment period key
  const typeMap = {
    1: 'period1',
    2: 'period2',
    3: 'period3',
    4: 'finished',
  };
  const certType = typeMap[i];

  // Image logic: Active if current stage's answers are completed, inactive if not
  let stageImg = `/assets/img/stage_${i}.svg`;
  const isStageActive = (i <= 3 && isCurrentPeriodCompleted) || (i === 4 && allPeriodsCompleted);

  if (!isStageActive) {
    stageImg = `/assets/img/stage_${i}_inactive.svg`;
  }

  const pdfUrl = `/api/core/users/certificate?type=${certType}`;
  const imgUrl = `/api/core/users/certificate?type=${certType}&media=image`;

  const handleDownload = () => {
    if (!certType) return;
    window.open(pdfUrl, '_blank');
  };

  const handleImageDownload = () => {
    if (!certType) return;
    window.open(imgUrl, '_blank');
  };

  // Native share handler (download and share PDF file)
  const handleShare = async () => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const file = new File([blob], 'certificate.pdf', { type: 'application/pdf' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: '榮譽證書',
          text: '來看看我的證書！',
          files: [file],
        });
      } else if (navigator.share) {
        await navigator.share({
          title: '榮譽證書',
          text: '來看看我的證書！',
          url: window.location.origin + pdfUrl,
        });
      } else {
        // Fallback: Facebook share with PDF link
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            window.location.origin + pdfUrl,
          )}`,
        );
      }
    } catch (err) {
      // Optionally show error
    }
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <img src={stageImg} />
      {/* Always render button containers to maintain consistent alignment */}
      <div className="mt-2" style={{ minHeight: '24px' }}>
        {showDownload ? (
          <button
            className="btn btn-link p-0 border-0"
            style={{ boxShadow: 'none' }}
            onClick={handleDownload}
            title="Download PDF"
          >
            <img src={'/assets/img/downloadPDF.svg'} alt="Download PDF" />
          </button>
        ) : (
          <div style={{ height: '24px', width: '24px' }} />
        )}
      </div>
      {showDownload && (
      <div className="m-3" style={{ minHeight: '24px' }}>
        <button
         className="btn btn-link d-flex align-items-center"
        style={{
          boxShadow: 'none', border: '6px solid #FFEAD2', borderRadius: '100px', padding: '6px 25px', gap: '10px',
        }}
          onClick={handleImageDownload}
          title="圖片下載"
        >
          <img src="/assets/img/download.svg" alt="Download Image"/>
            <span style={{ color: '#FF831E', fontWeight: 400 }}>
            圖片下載
            </span>
        </button>
      </div>
      )}
      <div className="mt-2" style={{ minHeight: '24px' }}>
        {showDownload ? (
          <button
            className="btn btn-link p-0 border-0 "
            style={{ boxShadow: 'none' }}
            onClick={handleShare}
            title="Share"
          >
            <FA icon={faShareAlt} style={{ fontSize: 24, color: '#844700' }} aria-label="Share" />
          </button>
        ) : (
          <div style={{ height: '24px', width: '24px' }} />
        )}
      </div>
    </div>
  );
};

const LatestBadge = ({
  answers = {}, // object: { period1: [], period2: [], period3: [] }
}) => {
  const periods = [
    answers.period1 || [],
    answers.period2 || [],
    answers.period3 || [],
  ];
  return (
    <div>
      <div className="row no-gutters align-items-center mb-3 justify-content-center">
        <h4 style={{ color: '#844700' }}>榮譽證書</h4>
      </div>
      {/* Desktop: grid, Mobile: horizontal scroll */}
      <div>
        {/* Responsive grid: 1 per row on xs, 2 per row on md/lg, 4 per row on xl+ */}
        <div className="row no-gutters align-items-center justify-content-between">
          {_.map([1, 2, 3, 4], (i) => (
            <div
              key={i}
              className="col-12 col-md-6 col-xl-3 p-2 d-flex justify-content-center"
            >
              <CertSection i={i} periods={periods} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestBadge;
